import { createSlice } from "@reduxjs/toolkit";

export const auth = createSlice({
  name: "auth",
  initialState: {
    user: {},
    token: null,
  },
  reducers: {
    login: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      const { user, token } = action.payload;
      if (user !== undefined) {
        state.user = user;
      }
      if (token !== undefined) {
        state.token = token;
      }
    },
    setUser: (state, action) => {
      const { user } = action.payload;
      console.log("redux setting", user);
      if (user !== undefined) {
        state.user = user;
      }
    },
    setToken: (state, action) => {
      const { token } = action.payload;
      if (token !== undefined) {
        state.token = token;
      }
    },
    logout: (state, action) => {
      state.user = {};
      state.token = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, logout, setUser, setToken } = auth.actions;

export default auth.reducer;
